<template>
<!-- 该组件已经废除不用 -->
  <div class="classManger">
   <!--  -->
    <!-- <el-aside class="sidebar">
      <el-button
        type="text"
        style="float:right;margin-top:5px;margin-right:10px"
        @click="openCampusDialog(1)"
        icon="el-icon-plus"
      >添加省份</el-button>
    </el-aside> -->
    <el-card>
      <el-row :gutter="20" style="height: 60px">
        <el-col :sm="12" :md="5" :lg="5">
          <el-input
            
            v-model="inp"
            style="width: 100%"
            placeholder="学员姓名/手机号"
            clearable
            maxlength="20"
          ></el-input>
        </el-col>
        
        <el-col :sm="12" :md="5" :lg="5">
          <el-button
            type="primary"
            @click="getPageList()"
            
            >查询</el-button
          >
        </el-col>
        <!-- <el-col :sm="12" :md="5" :lg="5" style="float: right">
          <el-button
            type="primary"
            style="float: right"
            @click="openCampusDialog(3)"
            icon="el-icon-plus"
            v-auth="'campusList_/campus/addCampus'"
            >添加校区</el-button
          >
        </el-col> -->
      </el-row>
      <el-table
        
        v-loading="loading"
        element-loading-text="拼命加载中"
        element-loading-background="rgba(255, 255, 255, 0.8)"
        class="teacherTable"
        :data="tableData"
        border
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        style="width: 100%"
      >
       
       
        <el-table-column prop="name" label="课后作业"></el-table-column>
        <el-table-column prop="mobile" width="120"  label="学员电话"></el-table-column>
        <el-table-column v-for="(item,index) in scopeListLength" :key="index" width="80" :label="`第${index+1}课时`" align="center">
          <template slot-scope="scope">
           <span>{{scope.row.scheduleInfoList[index].accuracy}}</span>
          </template>
        </el-table-column>
      </el-table>
      <div class="table_bottom">
        <el-pagination
          
          style="float: left"
          background
          layout="prev, pager, next, jumper,  total, sizes"
          :total="total"
          :page-size.sync="pageSize"
          :current-page.sync="currentPage"
          @size-change="sizeChange"
          @current-change="currentChange"
        ></el-pagination>
      </div>
      <div style="clear: both"></div>
    </el-card>

    <!-- 添加校区 -->
    <el-dialog
      @close="clearForm"
      class="addDialog"
      title="添加校区"
      :width="addwidth"
      :visible.sync="addCampusDialog"
    >
      <el-form
        :model="addCampusForm"
        status-icon
        :rules="rules"
        ref="addCampusForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="所属地区" prop="parentId">
          <el-cascader
            style="width: 100%"
            clearable
            v-model="addCampusForm.parentId"
            :show-all-levels="false"
            :props="CampusPropss"
            placeholder="请选择所属地区"
            :options="campusList"
            collapse-tags
          ></el-cascader>
        </el-form-item>
        <el-form-item label="校区名称" prop="name">
          <el-input
            v-model="addCampusForm.name"
            autocomplete="off"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="校区简称" prop="shortName">
          <el-input
            v-model="addCampusForm.shortName"
            autocomplete="off"
            maxlength="20"
          ></el-input>
        </el-form-item>
        <el-form-item label="是否启用" prop="active">
          <el-radio-group v-model="addCampusForm.active">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="-1">禁用</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button @click="addCampusDialog = false">取消</el-button>
          <el-button type="primary" @click="addCampus">提交</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- <drawer-detail
      v-if="drawerDetailShow"
      ref="drawerDetailRef"
      @drawerClose="drawerClose"
    ></drawer-detail> -->
  </div>
</template>

<script>
//import drawerDetail from "@/components/drawerDetail.vue";
export default {
  //components: { drawerDetail },
  data() {
    return {
      mousemoveShow: "",
      campusLableName: "",
      shortName: "",
      campusIdList: [],
      id: "", //校区id
      showEditorDialog: false,
      showAddDialog: false,
      loading: true, //表格是否加载中
      inp: "", //输入框绑定的值
      defaultProps: {
        children: "list",
        label: "name",
      },
      scopeListLength:0,
      tableData: [],
      queryData:{},
      currentPage: 1,
      pageSize: 10,
      drawerDetailShow: false,
      NodeClick: true,
      form: {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: "",
      },
      addCampusForm: {
        campusId: "",
        parentId: "",
        name: "",
        active: 1,
        level: 3,
        shortName: "",
      },
      editCampusForm: {
        campusId: "",
        shortName: "",
      },
      addCampusDialog: false,
      editCampusDialog: false,
      CampusTreeData: [],
      CampusProps: {
        value: "id",
        children: "children",
        label: "name",
        multiple: true,
      },
      CampusPropss: {
        value: "id",
        children: "children",
        label: "name",
      },
      rules: {
        name: [
          {
            required: true,
            message: "请输入教室名称",
            trigger: "blur",
          },
        ],
        parentId: [
          {
            required: true,
            message: "请选择校区",
            trigger: "change",
          },
        ],
        active: [
          {
            required: true,
            message: "请选择是否禁用",
            trigger: "change",
          },
        ],
      },
      addwidth: "30%",
      campusList: [],
      campusId: null,
      start: "",
      end: "",
      total: 0,
    };
  },
  methods: {
    // 金额充值
    drawerDetailClick(row, activeName) {
      this.drawerDetailShow = true;
      this.$nextTick(() => {
        this.$refs.drawerDetailRef.init(row, activeName, this.campusList);
      });
    },
    // 关闭抽屉
    drawerClose() {
      this.drawerDetailShow = false;
      this.getPageList();
    },
    sizeChange() {
      this.pageChange();
    },
    currentChange() {
      this.pageChange();
    },
    pageChange() {
      //分页发生变化时
     /*  let campusIdList = [];
      if (this.campusIdList && this.campusIdList.length > 0) {
        this.campusIdList.forEach((e) => {
          let len = e.length;
          campusIdList.push(e[len - 1]);
        });
      } */
      let data = {
        ...this.queryData,
        pageNumber: this.currentPage,
        pageSize: this.pageSize,
        
       /*  level: 3,
        campusIdList: this.campusIdList, */
      };
       this.loading = true;
      this.api.campus.signInGeneral(data).then((result) => {
        if (result.success) {
         
          this.tableData = result.data.records;
         if(this.tableData.length>0){ this.scopeListLength=this.tableData[0].scheduleInfoList.length}
        } else {
            this.$message.error(result.message);
          }
      }).finally(()=>{
         this.loading = false;
      });
    },
    paginationInit() {
      if (this.currentPage == 1 && this.total <= this.pageSize) {
        this.start = 1;
        this.end = this.total;
      } else if (this.currentPage * this.pageSize < this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.currentPage * this.pageSize;
      } else if (this.currentPage * this.pageSize >= this.total) {
        this.start = (this.currentPage - 1) * this.pageSize + 1;
        this.end = this.total;
      }
    },
    isActive(v) {
      //是否启用
      let data = {
        id: v.id,
        active: v.active == "1" ? "1" : "-1",
      };
      this.api.campus.active(data).then((result) => {
        if (result.success) {
          this.$message.success(result.message);
          this.getPageList();
        } else {
          this.$message.error(result.message);
          this.getPageList();
        }
      });
    },
    del(v) {
      this.$confirm("您确定要进行删除操作吗？", "系统消息", {
        type: "warning",
      })
        .then((result) => {
          this.api.classroom.deleteClassroom([{ id: v.id }]).then((result) => {
            if (result.success) {
              this.showEditorDialog = false;
              this.$message.success(result.message);
              this.getPageList();
            } else {
              this.$message.success(result.message);
            }
          });
        })
        .catch(() => {});
    },
    getCampusList() {
      this.api.campus
        .getCampusTree({ parentId: 1 })
        .then((result) => {
          for (let item of result.data) {
            if (item.children.length != 0) {
              for (let items of item.children) {
                if (items.children.length != 0) {
                  // for (let itemss of items.children) {
                  //   if (itemss.children.length != 0) {
                  //     delete itemss.children;
                  //   } else {
                  //     delete itemss.children;
                  //   }
                  // }
                  delete items.children;
                } else {
                  delete items.children;
                }
              }
            } else {
              delete item.children;
            }
          }
          this.campusList = result.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },
    openCampusDialog(level, id) {
      this.addCampusName = "添加校区";
      this.campusLableName = "校区名称";
      this.shortName = "校区简称";
      this.addCampusForm.level = 3;
      this.addCampusDialog = true;
    },
    getCampus(data) {
      this.api.campus.getCampus({ id: data }).then((result) => {
        if (result.success) {
          this.editCampusForm = result.data;
          if (this.editCampusForm.parentId === "1") {
            this.editCampusForm.parentId = "";
          }
        } else {
          this.$message.error(result.message);
        }
      });
    },
    addCampus() {
      this.$refs.addCampusForm.validate((val) => {
        if (val) {
          if (this.addCampusForm.parentId && this.addCampusForm.parentId.length > 0) {
            let len = this.addCampusForm.parentId.length;
            this.addCampusForm.parentId = this.addCampusForm.parentId[len - 1];
          }
          this.api.campus.addCampus(this.addCampusForm).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.addCampusDialog = false;
              this.showAbbreviationName = false;
            } else {
              this.$message.error(result.message);
            }
          });
        }
      });
    },
    deleteCampus(id, level) {
      let name = "";
      if (level === 3) {
        name = "校区";
      }
      this.$confirm("将会删除此" + name + "，是否确认删除？", "系统消息", {
        type: "warning",
      }).then(() => {
        this.api.campus.deleteCampus([{ id: id }]).then((result) => {
          if (result.success) {
            this.$message.success(result.message);
            this.NodeClick = true;
          } else {
            this.$message.error(result.message);
          }
        });
      });
    },
    getPageList() {
      this.loading = true;
      let campusIdList = [];
      /* if (this.campusIdList && this.campusIdList.length > 0) {
        this.campusIdList.forEach((e) => {
          let len = e.length;
          campusIdList.push(e[len - 1]);
        });
      } */
      const {
        classInfoId
      }=this.$route.query
      console.log(classInfoId)
      let data = {
        pageNumber: 1,
        pageSize: this.pageSize,
        name: this.inp,
        classInfoId,
        type: "homeWorkLog"
      };
      this.queryData=data
      this.api.campus.signInGeneral(data).then((result) => {
        if (result.success) {
          this.tableData = result.data.records;
          if(this.tableData.length>0){ this.scopeListLength=this.tableData[0].scheduleInfoList.length}
         
          this.total = Number(result.data.total);
          this.loading = false;
          this.paginationInit();
        } else {
            this.$message.error(result.message);
          }
      });
    },
    setaddDialogwidth() {
      var width = document.body.clientWidth;
      if (width < 560) {
        this.addwidth = "80%";
      } else if (width < 790) {
        this.addwidth = "70%";
      } else if (width < 970) {
        this.addwidth = "50%";
      } else if (width < 1300) {
        this.addwidth = "40%";
      } else {
        this.addwidth = "30%";
      }
    },
    clearForm() {
      this.form = {
        name: "",
        campusId: "",
        address: "",
        capacity: "",
        remark: "",
      };
    },
    clearAddCampusForm() {
      this.addCampusForm.name = "";
      this.addCampusForm.parentId = "";
      this.addCampusForm.active = 1;
      this.showAbbreviationName = false;
    },
    clearEditCampusForm() {
      this.editCampusForm.name = "";
      this.editCampusForm.parentId = "";
      this.editCampusForm.active = 1;
    },
    addClassRoom() {
      this.$refs.addForm.validate((val) => {
        if (val) {
          this.api.classroom.addClassroom(this.form).then((result) => {
            if (result.success) {
              this.$message.success(result.message);
              this.getPageList();
              this.clearForm();
              this.showAddDialog = false;
            } else {
              this.$message.error(result.message);
            }
          });
        } else {
          return false;
        }
      });
    },
  },
  watch: {
    addCampusDialog: function (newVal) {
      if (!newVal) {
        this.$refs.addCampusForm.resetFields();
        this.addCampusForm.parentId = "";
        this.addCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
    editCampusDialog: function (newVal) {
      if (!newVal) {
        this.$refs.editCampusForm.resetFields();
        this.editCampusForm.parentId = "";
        this.editCampusForm.name = "";
        this.NodeClick = true;
      } else {
      }
    },
  },
  created() {
    this.getCampusList();
    this.getPageList();
  },
  mounted() {
    window.onresize = () => {
      this.setaddDialogwidth();
    };
  },
};
</script>
<style scoped>
.sidebar {
  width: 245px !important;
  border-radius: 4px;
  overflow: auto;
  background: #fff;
}
.sidebarRight {
  padding: 0px 20px !important;
}

.sidebar .title,
.sidebarRight .title {
  height: 50px;
  line-height: 50px;
  padding-left: 20px;
  border-bottom: 1px solid #e5ecf0;
}

.sidebarRight .search {
  background: #66b1ff !important;
  border: 0;
  outline: none;
  border-radius: 0;
  height: 40px;
  color: white !important;
}

.classManger .caret-wrapper {
  position: absolute;
  right: 0;
  top: -5px;
}
.table_bottom {
  margin: 20px 0;
}
.left-top-bottom {
  float: right;
  color: #4d94ff;
  font-weight: 600;
  margin-left: 10px;
  margin-top: 2px;
}
.campusManage-search {
  padding: 0px 10px;
}
.campusManage-tree {
  margin-top: 10px;
}
.span-ellipsis {
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/classRoomTeaching/generalSituation.vue